import { useQuery } from "@tanstack/react-query";
import { getWetReadsForQuery } from "../queries/getWetRead";

export const useWetReads = (modalityId) => {
  return useQuery({
    queryKey: ["wetReads", modalityId],
    queryFn: () => getWetReadsForQuery(modalityId),
  });
};
